export enum Browser {
  chrome = 'chrome',
  firefox = 'firefox',
  safari = 'safari',
  opera = 'opera',
  edge = 'edge',
  ie = 'ie',
  other = 'other',
}

export const getBrowserDetails: () => {
  browserName: Browser;
  fullVersion: string;
  majorVersion: number;
} = () => {
  const nAgt = navigator.userAgent;
  let browserName = Browser.other;
  let fullVersion = '';
  let majorVersion = 0;
  let verOffset, ix;

  // In Opera, the true version is after "OPR" or after "Version"
  if ((verOffset = nAgt.indexOf('OPR')) != -1) {
    browserName = Browser.opera;
    fullVersion = nAgt.substring(verOffset + 4);
    if ((verOffset = nAgt.indexOf('Version')) != -1) fullVersion = nAgt.substring(verOffset + 8);
  }

  // In MS Edge, the true version is after "Edg" in userAgent
  else if ((verOffset = nAgt.indexOf('Edg')) != -1) {
    browserName = Browser.edge;
    fullVersion = nAgt.substring(verOffset + 4);
  }

  // In MSIE, the true version is after "MSIE" in userAgent
  else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
    browserName = Browser.ie;
    fullVersion = nAgt.substring(verOffset + 5);
  }

  // In Chrome, the true version is after "Chrome"
  else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
    browserName = Browser.chrome;
    fullVersion = nAgt.substring(verOffset + 7);
  }

  // In Safari, the true version is after "Safari" or after "Version"
  else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
    browserName = Browser.safari;
    fullVersion = nAgt.substring(verOffset + 7);
    if ((verOffset = nAgt.indexOf('Version')) != -1) fullVersion = nAgt.substring(verOffset + 8);
  }

  // In Firefox, the true version is after "Firefox"
  else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
    browserName = Browser.firefox;
    fullVersion = nAgt.substring(verOffset + 8);
  }

  // trim the fullVersion string at semicolon/space if present
  if ((ix = fullVersion.indexOf(';')) != -1) fullVersion = fullVersion.substring(0, ix);
  if ((ix = fullVersion.indexOf(' ')) != -1) fullVersion = fullVersion.substring(0, ix);

  majorVersion = parseInt('' + fullVersion, 10);
  if (isNaN(majorVersion)) {
    fullVersion = '' + parseFloat(navigator.appVersion);
    majorVersion = parseInt(navigator.appVersion, 10);
  }

  return {
    browserName,
    fullVersion,
    majorVersion,
  };
};

export const hasTouchSupport: boolean = 'ontouchstart' in document.documentElement;

export const browserName: Browser = getBrowserDetails().browserName;

export const isMobileSafari: boolean =
  browserName === Browser.safari && !navigator.userAgent.match('CriOS');

export const canInstallIosPwa =
  isMobileSafari && hasTouchSupport && !window.matchMedia('(display-mode: standalone)').matches;
export const canInstallAndroidPwa =
  browserName !== Browser.safari &&
  hasTouchSupport &&
  !window.matchMedia('(display-mode: standalone)').matches;

export const isBrowserVersionAcceptable: () => boolean = () => {
  const browserDetails = getBrowserDetails();
  return (
    (browserDetails.browserName === Browser.chrome && browserDetails.majorVersion >= 84) ||
    (browserDetails.browserName === Browser.edge && browserDetails.majorVersion >= 84) ||
    (browserDetails.browserName === Browser.firefox && browserDetails.majorVersion >= 78) ||
    (browserDetails.browserName === Browser.safari && browserDetails.majorVersion >= 15)
  );
};
